import baseTheme from "@nextblick/gatsby-theme-hdb/src/gatsby-plugin-theme-ui";
import { merge } from "theme-ui";

// merge will deeply merge custom values with the theme's defaults
export default merge(baseTheme, {
  colors: {
    text: "#262626",
    primary: "#d51031",
    secondary: "#d51031",
    backgroundLight: "#ffcc00",
    backgroundDark: "#863626",
    backgroundDarkText: "#fff",
    menuBorderColor: "#eccdab",
    productDividerColor: "#eccdab",
    headerBg: "#eccdab",
    footerBg: "#eccdab",
    headerText: "#863626",
    footerText: "#863626",
  },
  fonts: {
    body: "Optima, sans-serif",
    heading: "Bobby Jones Soft, sans-serif",
    headingSecondary: "Satisfy, sans-serif",
  },
  sizes: {
    headerHeight: 100,
    headerLogoHeight: 60,
    subMenuHeight: 60,
  },
  text: {
    title: { fontWeight: "bold" },
    hero: { fontWeight: "bold", color: "#ffec00" },
    boxed: {
      backgroundColor: "transparent",
      color: "text",
      textTransform: "uppercase",
    },
    underlined: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "1.5rem",

      "&::after": {
        content: '""',
        display: "block",
        width: "50%",
        height: "1px",
        background: "text",
        marginTop: "1rem",
        maxWidth: "250px",
      },
    },
    nav: {
      fontWeight: "normal",
      fontSize: "1.2rem",
      "&.active": {
        color: "secondary",
      },
      "&:hover": {
        color: "secondary",
      },
    },
  },
  buttons: {
    primary: {
      color: "white",
    },
  },
  forms: {
    select: {
      backgroundColor: `primary`,
    },
  },
  styles: {
    root: {
      p: {
        fontSize: "20px",
      },
      "ul li": {
        fontSize: "20px",
        textAlign: "left",
      },
    },
  },
});
